import React from "react";
import SultangaziSidebar from "../Sidebar/SultangaziSidebar";
import SultangaziOtherServices from "../ServiceAreas/SultangaziServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const SultangaziIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        SULTANGAZİ HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Sultangazi bölgesinde halı ve koltuk temizliği, ev hijyeninin en
            önemli parçalarından biridir. Toz, polen, evcil hayvan tüyleri gibi
            unsurlar ev tekstil ürünlerinde birikir. Bu durum hem sağlık açısından
            risk oluşturur hem de yaşam kalitesini düşürür.
          </p>

          <p>
            Sultangazi Halı Yıkama olarak, modern teknolojiye sahip ekipmanlarla
            halılarınızı ve koltuklarınızı derinlemesine temizliyoruz. Yerinde
            koltuk yıkama, perde yıkama, yorgan ve battaniye temizliği gibi hizmetler
            sunuyoruz.
          </p>

          <p>
            <strong>Öne çıkan hizmetlerimiz:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Ücretsiz Servis – Kapıdan alım ve teslim</li>
            <li>Organik, çevre ve cilt dostu temizlik ürünleri</li>
            <li>Derinlemesine halı ve koltuk yıkama</li>
            <li>Kuru köpük ve buharlı temizlik seçenekleri</li>
            <li>Anti-alerjen ve anti-bakteriyel uygulamalar</li>
            <li>Kısa sürede teslimat – 48 Saat içinde</li>
          </ul>

          <p>
            Uğurmumcu, Habipler, Cebeci, Esentepe, İsmetpaşa gibi Sultangazi’nin
            birçok mahallesinde aktif olarak hizmet veriyoruz. Profesyonel
            ekibimizle aynı gün servis imkanı sunuyoruz.
          </p>

          <p>
            Halılarınız tam otomatik makinelerde, koltuklarınız kumaşına özel
            sistemlerle yıkanır. Tüm işlem süreci boyunca ürünlerinizin yapısına
            zarar verilmeden hijyenik temizlik sağlanır.
          </p>

          <p>
            Hizmetimizden faydalanmak ve detaylı bilgi almak için hemen bizimle
            iletişime geçebilirsiniz.
          </p>

          <SultangaziSidebar />
          <SultangaziOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default SultangaziIntro;
